import React, { useState, useEffect } from 'react';
import charm_heart_logo from '../../assets/charm-logo.png';
import { RIGHT_ARROW_ICON, LEFT_ARROW_ICON } from './Icons';
import { useUser } from '../../UserContext';
import charm_small_logo from '../../assets/Charm_icon_ylw_wht.png'
// Common CSS classes
const styles = {
    // if you edit the sidebarContainer, you must also edit the contentContainer in VendorProfile sm:ml-[27rem] to match the width here
    sidebarContainer: 'w-[27rem] pt-3 left-0 h-[100vh] flex flex-col items-start bg-gradient-to-b from-[#26051C] to-[#b31d7c]',
    sidebarContainerCollapsed: 'w-[5rem] pt-5 left-0 h-[100vh] flex flex-col items-center bg-gradient-to-b from-[#26051C] to-[#b31d7c]',
    logoButton: 'w-55 px-5',
    logoButtonIcon: 'w-[2rem] xs:w-30 xl:w-25',
    collapseButtonContainer: 'w-full flex justify-center',
    collapseButton: 'text-white rounded-full min-w-12 min-h-12 max-h-12 flex items-center justify-center',
    categoryButtonBase: 'flex items-center mt-2 py-3 px-[5rem] w-full font-all-round-gothic justify-start text-white',
    categoryButtonBaseCollapsed: 'flex flex-col items-center justify-center mt-1 py-2 w-full font-all-round-gothic text-xs space-y-1 text-white',
    categoryButtonSelected: 'bg-exploreCategoriesBackground font-semibold',
    categoryButtonUnselected: 'font-normal',
    iconContainer: 'flex-shrink-0 flex items-center justify-center sm:mx-2 mx-4',
    icon: 'w-8 h-8',
    buttonText: 'text-2xl',
    buttonTextCollapsed: 'text-xs mt-1',
    contentContainer: 'flex-grow ml-[18rem] p-8 overflow-y-auto h-[calc(100%-4rem)]',
    contentContainerCollapsed: 'flex-grow ml-[7rem] p-8 overflow-y-auto h-[calc(100%-4rem)]',
    toggleButton: 'text-white rounded-full min-w-12 min-h-12 max-h-12 flex items-center justify-center bg-exploreCategoriesBackground',
};

const ToggleButton = ({ onClick, isExpanded }) => (
    <button
        className={isExpanded ? styles.collapseButton : styles.toggleButton}
        onClick={onClick}
    >
        {isExpanded ? LEFT_ARROW_ICON : RIGHT_ARROW_ICON}
    </button>
);

const CategoryButton = ({ label, isSelected, onClick, icon, isExpanded, isActive }) => (
    <button
        className={`${isExpanded ? styles.categoryButtonBase : styles.categoryButtonBaseCollapsed} ${isSelected
            ? styles.categoryButtonSelected
            : styles.categoryButtonUnselected
            } ${!isActive ? 'opacity-30' : 'opacity-70'}`}
        onClick={() => onClick(label)}
        disabled={!isActive}
    >
        <span className={styles.iconContainer}>
            {React.cloneElement(icon, { className: styles.icon })}
        </span>
        {isExpanded ? (
            <span className={styles.buttonText}>{label}</span>
        ) : (
            <span className={styles.buttonTextCollapsed}>{label}</span>
        )}
    </button>
);

export const Sidebar = ({
    navigate,
    buttonLabels,
    selectedCategory,
    handleCategoryChange,
    buttonIcons,
}) => {
    const [categoriesExpanded, setCategoriesExpanded] = useState(true);
    const handleExpandedClick = () => setCategoriesExpanded(!categoriesExpanded);
    const { userPermissions } = useUser();
    // Collapse sidebar on small screens
    useEffect(() => {
        if (!userPermissions) {
            navigate('/vendors/loading');
        }

        const updateSidebarState = () => {
            if (window.innerWidth < 640) { // Tailwind's small screen breakpoint
                setCategoriesExpanded(false);
            }
            else {
                setCategoriesExpanded(true);
            }
        };
        window.addEventListener('resize', updateSidebarState);
        updateSidebarState();

        return () => window.removeEventListener('resize', updateSidebarState);
    }, []);

    return (
        <div
            className={
                categoriesExpanded ? styles.sidebarContainer : styles.sidebarContainerCollapsed
            }
        >
            {categoriesExpanded ? (
                <button onClick={() => navigate("/vendors")}>
                    <img
                        src={charm_heart_logo}
                        alt="Logo"
                        className={styles.logoButton}
                    />
                </button>
            ) : (
                <button onClick={() => navigate("/vendors")}>
                    <img src={charm_small_logo} alt="Logo" className={styles.logoButtonIcon} />
                </button>
            )}
            {userPermissions &&
                <div className="mt-4 w-full">
                    {buttonLabels.map((label, index) => (
                        <CategoryButton
                            key={index}
                            label={label}
                            isSelected={selectedCategory === label}
                            onClick={handleCategoryChange}
                            icon={buttonIcons[label]}
                            isExpanded={categoriesExpanded}
                            isActive={userPermissions[label]}
                        />
                    ))}
                </div>
            }
            {userPermissions && !userPermissions['Dashboard'] &&
                <div class="bg-white p-2 m-3 rounded-md shadow-sm max-w-md hidden xs:block justify-center">
                    <div>
                        ⚠️ All tabs will be active once you create your first listing.
                    </div>
                </div>
            }
            <div className={styles.collapseButtonContainer}>
                {/* <ToggleButton
                    onClick={handleExpandedClick}
                    isExpanded={categoriesExpanded}
                /> */}
            </div>
        </div>
    );
};

export default Sidebar;
